import { IProposal } from 'interfaces/proposals/proposal';
import { useState } from 'react';

const useModal = (p?: IProposal) => {
  const [isOpenVotingModal, setIsOpenVotingModal] = useState(false);
  const [isOpenContentModal, setIsOpenContentModal] = useState(false);
  const [isOpenCommunityInfoModal, setIsOpenCommunityInfoModal] = useState(false);
  const [isOpenNewProposalModal, setIsOpenNewProposalModal] = useState(false);
  const [isOpenContentCreatePostModal, setIsOpenContentCreatePostModal] = useState(false);
  const [isOpenPlaylistsModal, setIsOpenPlaylistsModal] = useState(false);
  const [isOpenPromoteModal, setIsOpenPromoteModal] = useState(false);
  const [isOpenTransferModal, setIsOpenTransferModal] = useState(false);
  const [isOpenTransferToSavingsModal, setIsOpenTransferToSavingsModal] = useState(false);
  const [isOpenWithdrawFromSavingsModal, setIsOpenWithdrawFromSavingsModal] = useState(false);
  const [isOpenCancelWithdrawFromSavingsModal, setIsOpenCancelWithdrawFromSavingsModal] = useState(false);
  const [isOpenTransferToVestingModal, setIsOpenTransferToVestingModal] = useState(false);
  const [isOpenDelegateModal, setIsOpenDelegateModal] = useState(false);
  const [isOpenPowerDownModal, setIsOpenPowerDownModal] = useState(false);
  const [isOpenLoginModal, setIsOpenLoginModal] = useState(false);
  const [isOpenSignupModal, setIsOpenSignupModal] = useState(false);
  const [isOpenGenerateLinkModal, setIsOpenGenerateLinkModal] = useState(false);
  const [isOpenWitnessVoteModal, setIsOpenWitnessVoteModal] = useState(false);
  const [proposal, setProposal] = useState(p);

  function toggleVotingModal() {
    setIsOpenVotingModal(!isOpenVotingModal);
    setProposal(proposal);
  }

  function toggleContentModal() {
    setIsOpenContentModal(!isOpenContentModal);
    setProposal(proposal);
  }
  function toggleCommunityInfoModal() {
    setIsOpenCommunityInfoModal(!isOpenCommunityInfoModal); 
  }

  function toggleNewProposalModal() {
    setIsOpenNewProposalModal(!isOpenNewProposalModal);
  }
  function toggleContentCreatePostModal() {
    setIsOpenContentCreatePostModal(!isOpenContentCreatePostModal);
  }

  function toggleLoginModal() {
    setIsOpenLoginModal(!isOpenLoginModal);
  }
  function toggleSignupModal() {
    setIsOpenSignupModal(!isOpenSignupModal);
  }
  function toggleGenerateLinkModal() {
    setIsOpenGenerateLinkModal(!isOpenGenerateLinkModal);
  }
  function toggleWitnessVoteModal() {
    setIsOpenWitnessVoteModal(!isOpenWitnessVoteModal);
  }
  function togglePlaylistsModal() {
    setIsOpenPlaylistsModal(!isOpenPlaylistsModal);
  }
  function togglePromoteModal() {
    setIsOpenPromoteModal(!isOpenPromoteModal);
  }
  function toggleTransferModal() {
    setIsOpenTransferModal(!isOpenTransferModal);
  }
  function toggleTransferToSavingsModal() {
    setIsOpenTransferToSavingsModal(!isOpenTransferToSavingsModal);
  }
  function toggleWithdrawFromSavingsModal() {
    setIsOpenWithdrawFromSavingsModal(!isOpenWithdrawFromSavingsModal);
  }
  function toggleCancelWithdrawFromSavingsModal() {
    setIsOpenCancelWithdrawFromSavingsModal(!isOpenCancelWithdrawFromSavingsModal);
  }
  function toggleTransferToVestingModal() {
    setIsOpenTransferToVestingModal(!isOpenTransferToVestingModal);
  }
  function toggleDelegateModal() {
    setIsOpenDelegateModal(!isOpenDelegateModal);
  }
  function togglePowerDownModal() {
    setIsOpenPowerDownModal(!isOpenPowerDownModal);
  }

  return {
    isOpenLoginModal,
    isOpenSignupModal,
    isOpenGenerateLinkModal,
    isOpenWitnessVoteModal,
    isOpenVotingModal,
    isOpenContentModal,
    isOpenCommunityInfoModal,
    isOpenNewProposalModal,
    isOpenContentCreatePostModal,
    isOpenPlaylistsModal,
    isOpenPromoteModal,
    isOpenTransferModal,
    isOpenTransferToSavingsModal,
    isOpenWithdrawFromSavingsModal,
    isOpenCancelWithdrawFromSavingsModal,
    isOpenTransferToVestingModal,
    isOpenDelegateModal,
    isOpenPowerDownModal,
    proposal,
    toggleLoginModal,
    toggleSignupModal,
    toggleGenerateLinkModal,
    toggleWitnessVoteModal,
    toggleVotingModal,
    toggleCommunityInfoModal,
    toggleContentModal,
    toggleNewProposalModal,
    togglePlaylistsModal,
    togglePromoteModal,
    toggleTransferModal,
    toggleTransferToSavingsModal,
    toggleWithdrawFromSavingsModal,
    toggleCancelWithdrawFromSavingsModal,
    toggleTransferToVestingModal,
    toggleDelegateModal,
    togglePowerDownModal,
    toggleContentCreatePostModal
  }
};

export default useModal;